import styled from "styled-components";
import { Tabs, Modal, Button } from "antd";
import {
  SectionLastHeading,
  CommonTable,
  DataValue,
  StyleLessButton,
  UnderlinePurpose
} from "../../../../../../CommonComponents/commonStyles";

export const StyleLessButtons = styled(StyleLessButton)`
position: relative;
top: 42px;
z-index: 100;
@media only screen and (max-width: 990px) {
 top:0;
}
`
export const UnderLinkButton = styled.a` 
  font-weight: ${props => props.theme.fontWeight.bold};
  font-size: ${props => props.theme.fontSize.secondary};
  padding: ${props => props.noPadding ? '0' : '0px 10px'};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h5};
  color: ${props => props.disable ? 'rgba(0, 0, 0, 0.25)' : props.theme.fontColors.primary} !important;
  text-decoration: underline;
  &:hover :focus {
    color: ${props => props.theme.fontColors.primary} !important;
    text-decoration: underline;
  }
  a {
    color: ${props => props.theme.fontColors.primary} !important;
    text-decoration: underline;
  }

  ${({ wid30 }) => (wid30 ? `min-width:30%;` : `min-width:none;`)}
  
`;

export const DisableLink = styled.div`
  width: 40%;
  margin: 0 auto;
  font-size: ${props => props.theme.fontSize.secondary};
  padding: 0px 10px;
  font-family: ${props => props.theme.fontSize.helveticaNeueMedium};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h5};
  color: ${props => props.theme.fontColors.textColor} !important;
  
  ${({ wid30 }) => (wid30 ? `min-width:30%;` : `min-width:none;`)}
  
`;

export const UnderLButton = styled.a`
  width: 40%;
  margin: 4px 0px 1px 20px;
  padding: 0px 10px;
  font-size:  ${props => props.theme.fontSize.primary};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h5};
  color: ${props => props.theme.fontColors.primary} !important;
  text-decoration: underline;
  &:hover :focus {
    color: ${props => props.theme.fontColors.primary} !important;
    text-decoration: underline;
  }
  a {
    color: ${props => props.theme.fontColors.primary} !important;
    text-decoration: underline;
  }
  ${({ wid30 }) => (wid30 ? `min-width:30%;` : `min-width:none;`)}
  
`;

export const LinkButton = styled.a`
 font-size:15px;
  font-family: ${props => props.theme.fontSize.helveticaNeue};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: ${props => props.theme.lineHeight.h5};
  // letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.fontColors.primary} !important;
  text-decoration: underline;
  &:hover :focus {
    color: ${props => props.theme.fontColors.primary} !important;
    text-decoration: underline;
  }
  a {
    color: ${props => props.theme.fontColors.primary} !important;
    text-decoration: underline;
  }
  ${({ wid30 }) => (wid30 ? `min-width:30%;` : `min-width:none;`)}
  
`;
export const TableData = styled.div`
  width: ${props => props.width ? props.width: 'auto'};
  font-size: ${props => props.theme.fontSize.tableFont};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-style: normal;
  word-break: ${props => props.break ? 'normal' : (props.ie ? 'break-all': 'break-word') };
  color: ${props => props.theme.fontColors.textColor};
  text-align: ${props => props.textAlign ? props.textAlign: 'left'};
  @media only screen and (max-width: 1050px) {   
    line-height: ${props => props.theme.lineHeight.secondary};
  }  
`;

export const TitleData = styled.div`
  font-size: 15px;
  word-break: ${props => props.break ? 'normal' : (props.ie ? 'break-all': 'break-word') };  
`

export const ViewButton = styled(Button)`
  min-width:103px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  height:30px;
  font-size:${props => props.theme.fontSize.secondary};;
background-color: ${props => props.theme.colors.white};
color: ${props => props.theme.colors.primaryColor};
border: 1px solid ${props => props.theme.colors.border};
font-stretch: ${props => props.theme.fontStretch.normal};
border-radius: 18px;
letter-spacing: ${props => props.theme.letterSpacing.normal};
display: flex;
justify-content: center;
align-items: center;
&:hover,
:focus {
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.primaryColor};
  border: 1px solid ${props => props.theme.colors.border};
}
@media only screen and (max-width: 990px) {
  font-size: ${props => props.theme.fontSize.secondary};
  line-height: ${props => props.theme.lineHeight.secondary};
}
@media only screen and (min-width: 576px) and (max-width: 991px) {
}
`;

export const SectionHeading = styled(SectionLastHeading)`
  margin-bottom: 20px;
  font-stretch: normal;
  line-height: normal;
`;

export const UnderLinePurposeLink = styled(UnderlinePurpose)`
 font-size: 15px;
`;

export const CustomModal = styled(Modal)`
  .ant-modal-footer {
    display: flex;
    justify-content: center;
  }
  .ant-modal-footer > * {
    width: 200px;
  }
  .ant-calendar-picker-container{
    left: 0px !important;
    z-index: 1000;
    }
`;

export const Links = styled.a`
  text-decoration: none !important;
  font-family: ${props => props.theme.fontFamily.helveticaNeueMedium};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal};
  font-style: normal;
  font-stretch: ${props => props.theme.fontStretch.normal};
  line-height: 18px;
  letter-spacing: ${props => props.theme.letterSpacing.normal};
  color: ${props => props.theme.colors.primaryColor} !important;
  display: block;
  :hover {
    color: ${props => props.theme.colors.primaryColor} !important;
    text-decoration: none;
  }
  @media only screen and (max-width: 990px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
  @media only screen and (max-width: 576px) {
    font-size: ${props => props.theme.fontSize.primary};
    line-height: ${props => props.theme.lineHeight.primary};
  }
`;

export const InvestmentTable = styled(CommonTable)`
////////////////////////////////////////////////Common
  th:first-child{
    padding-left:0px;
    padding-right:0px;
  }
  tr:nth-child(odd){
    background-color: #f2f2f2;
   
  }

  .ant-table-tbody > tr > td {
    border: none !important;
  }
  .ant-table-thead > tr > .ant-table-column-has-actions .ant-table-column-has-sorters{
    left:5px;
  }
  // 

  .ant-table-thead > tr > th .ant-table-column-sorter .ant-table-column-sorter-inner {
    margin-left:0px;
  }

  .ant-table-thead > tr > th, .ant-table-tbody > tr > td {
    padding: 16px 13px;
  }

  .ant-table-thead > tr:first-child > th:first-child {
    padding: 16px 0px;
  }

  .ant-table-column-has-actions{
    padding-right:0px !important;
  }

  ////////////////////////////////////////////////Main Table

  .main {
    .ant-table {
      .ant-table-body {
        
        tr {
          &:nth-child(odd) {
            background-color: #f4f3f3 !important;
          }
        }
      }
    }
  }
 

  .ant-table-fixed-header {
    .ant-table-scroll {
      .ant-table-header {
        padding-bottom: 0px !important;
        margin-bottom: -6px !important;
        background: #ffffff;
      }
      box-sizing:border-box;
      border-width: 0px 1px 1px 1px !important;
      border-style: solid !important;
      border-color: ${props => props.theme.border.primary} !important;
    }
  }

  th {
    background: #fff !important;
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    font-size: ${props => props.theme.fontSize.secondary};
    font-weight: ${props => props.theme.fontWeight.bold} !important;
    font-style: normal;
    font-stretch: ${props => props.theme.fontStretch.normal};
    line-height: ${props => props.theme.lineHeight.primary};
    // letter-spacing: ${props => props.theme.letterSpacing.normal};
    color: #022737 !important;

    @media only screen and (max-width: 990px) { 
      font-size:0.6rem;
     }
  }
  .ant-table-column-title{
    // margin-left:-14px;
  }

  .ant-table-thead {
    vertical-align: bottom;
    tr { 
    
      th {    
        display:flex !important; 
        .ant-table-column-sorters{
          display:flex;
          flex-direction: row-reverse;
          justify-content:flex-end;
        }
        .ant-table-column-sorter {
          transform: translate(0px,4px);
          
         
        }

        border-bottom-width: 2px;
        border-bottom-style: solid;
        border-bottom-color: ${props => props.theme.border.primary};
      } 
      .ant-table-column-title {
        // transform:translate(20px,0px);
        
      }
      border-bottom-width: 2px;
      border-bottom-style: solid;
      border-bottom-color: ${props => props.theme.border.primary};
    }

    }
  }
  
`;

export const TabsPaneEA = styled(Tabs)`
  &&& {
    .ant-tabs-bar {
      margin: 0;
     
      border-bottom: 1px solid ${props => props.theme.border.primary};
      // @media (max-width: 576px) {
      //   height:56px;
      // }
      @media (max-width: 990px) {
        height:56px;
      }
    }
    .ant-tabs-nav-wrap{
      .ant-tabs-nav-scroll
      .ant-tabs-nav
      .ant-tabs-nav-animated {
      font-family: ${props => props.theme.fontFamily.helveticaNeue} !important;
      font-size: 15px;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      // letter-spacing: 0.6px;
    }
    
    .ant-tabs-tab-active {
      font-size: ${props => props.theme.fontSize.primary};
      border-style: solid;
      border-radius: 0px;
      border-width: 3px 0px 0px 0px !important;
      border-color: #006778 !important;
      border-bottom-color: #ffffff !important;
      background-color: #ffffff !important;
      border-right-width: 1px !important;
      border-right-color: ${props => props.theme.border.primary} !important;
     // font-weight: bold !important;
      font-family: ${props =>
        props.theme.fontFamily.helveticaNeueBold} !important;
      color: ${props => props.theme.colors.primaryColor} !important;
      margin-right: 0px !important;
      padding: 6px 18px 0px 18px !important;
      @media(max-width: 576px){
      padding: 7px 18px 0px 18px !important;
      }
      }
      div > .ant-tabs-tab-active:first-child{
      border-left-width: 1px !important;
      border-left-style: solid !important;
      border-left-color: ${props => props.theme.border.primary}!important;
      }
      .ant-tabs-ink-bar {
      background-color: transparent!important
      }
      .ant-tabs-tab {
      font-size: ${props => props.theme.fontSize.primary};
      border-style: solid;
      border-radius: 0px;
      border-width: 3px 0px 1px 0px;
      border-bottom-color: ${props => props.theme.border.primary};
      border-right-width: 1px;
      border-right-color: ${props => props.theme.border.primary};
      background-color: #f4f3f3;
      font-family: ${props =>
        props.theme.fontFamily.helveticaNeueBold} ;
      //font-weight: bold;
      color: #505050;
      margin-right: 0px !important;
      height: 56px !important;
      padding: 6px 18px 9px 18px !important;
      @media (max-width: 990.98px) {
        font-size: ${props => props.theme.fontSize.secondary};
        overflow:hidden;
        line-height:38px;
        text-overflow:ellipsis;
        text-align: center;
        padding: 7px 10px 0px 10px !important;
      }
    }
  }
`;


export const DataExportPrint = styled(DataValue)`
margin: 0px 5px;
font-family: ${props => props.theme.fontFamily.helveticaNeue};
font-size: ${props => props.theme.fontSize.primary};
font-weight: ${props => props.theme.fontWeight.normal};
font-style: normal;
font-stretch: ${props => props.theme.fontStretch.normal};
line-height: ${props => props.theme.lineHeight.primary};
letter-spacing: ${props => props.theme.letterSpacing.normal};
color: ${props => props.theme.colors.primaryColor} !important;
text-decoration: underline;
display: block;
:hover {
  color: ${props => props.theme.colors.primaryColor} !important;
  text-decoration: underline;
}
@media only screen and (max-width: 990px) {
  font-size: ${props => props.theme.fontSize.primary};
  line-height: ${props => props.theme.lineHeight.primary};
}
@media only screen and (max-width: 576px) {
  font-size: ${props => props.theme.fontSize.secondary};
  line-height: ${props => props.theme.lineHeight.secondary};
}
`;

export const IconsPlace = styled.div`
  margin-left: 101px;
`;

export const IconsPlaceNew = styled.div`
  display: flex;
  justify-content: flex-end;
  position: relative;
  top: 35px;
  @media (max-width: 990px) {
    justify-content: flex-start !important;
    position: initial;
    top: -20px;
    margin-bottom: 30px;
  }
  @media (max-width: 576px) {
    margin-bottom: 20px;
  }
`;

export const IconPadding = styled.div`
  display: flex;
  justify-content: space-around;
  margin-left: 26px;
  cursor: pointer;
  @media (max-width: 990px) {
    margin-left: 0px;
    margin-right: 26px;
  }
`;

export const FilterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 80px;

 
`;

export const BtnWrapper = styled.div`
display:flex;
& img.preloader{
  height:3rem;
  padding:0;
}
`;


export const ToLabel = styled.div`
text-align:left;`;

export const FlexCentered = styled.div`
display:flex;
justify-content: space-between;
align-items: center;
${({mr10})=> (mr10 ? `margin-right:10px`:``)}
`;

export const CenterAlign = styled.div`
text-align:center;
`;

export const FilterBtn = styled.div`
  margin: 20px 0px;
  border: 1px solid ${props => props.theme.colors.border};
  display:flex;
  max-width: 80px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  > img{
    margin-left: 5px;
  }
`;

export const HiddenFrequency = styled.div`
  display: none;
`;

export const Searchbar = styled.div`
  display: flex;
  flex-direction: row;
  margin: 20px 0px;
  @media only screen and (max-width: 990px) {
    flex-wrap: wrap;
  }
  @media only screen and (max-width: 578px) {
    flex-wrap: wrap;
    width: 80%;
    & > * {
      padding: 10px 0px;
    }
  }
`;


export const GrantMob = styled.div`
overflow:scroll;
`;


export const Blocks = styled.div`
${({h})=>(h ? `height:${h}px`:``)}
${({flex})=>(flex===2 ? `display:flex;flex-direction:column`:`display:flex;`)}
${({center})=>(center ? `justify-content:center`:``)}
${({mt})=>(mt && `margin-top:${mt}px`)}
`;

export const ContentMaker = styled.div`
  white-space: pre-line;
`;

export const RegrantLoader = styled.div`
  padding: 0 20px;
  display: flex;
  align-items: center;
`;

export const GrantActionItems = styled.a`
  font-family: ${props => props.theme.fontFamily.helveticaNeue} !important;  
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: ${props => props.theme.fontWeight.normal} !important;
  font-stretch: ${props => props.theme.fontStretch.normal} !important;
  font-style: normal !important;
  line-height: ${props => props.theme.lineHeight.h5} !important;
  letter-spacing: ${props => props.theme.lineHeight.normal} !important;
  cursor: ${props => props.disabled ? 'null' : 'pointer'};
  color: ${props => props.disabled ? 'rgba(0, 0, 0, 0.25)' : props.theme.fontColors.textColor} !important;
`;

export const GrantActionTitle = styled.div`
  text-align: center;    
`;